import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/.umi-production/LocaleWrapper.jsx';
import _dvaDynamic from 'dva/dynamic';

const Router = require('dva/router').routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/user',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../../layouts/UserLayout'),
          LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/UserLayout').default,
    routes: [
      {
        path: '/user',
        redirect: '/user/login',
        exact: true,
      },
      {
        path: '/user/login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Account/Login/Login'),
              LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                .default,
            })
          : require('../Account/Login/Login').default,
        exact: true,
      },
    ],
  },
  {
    path: '/heading',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../../layouts/UserLayout'),
          LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/UserLayout').default,
    routes: [
      {
        path: '/heading',
        redirect: '/heading/login',
        exact: true,
      },
      {
        path: '/heading/login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Account/Uni/Login'),
              LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                .default,
            })
          : require('../Account/Uni/Login').default,
        exact: true,
      },
    ],
  },
  {
    path: '/uni',
    routes: [
      {
        path: '/uni',
        redirect: '/uni/login',
        exact: true,
      },
      {
        path: '/uni/login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Account/Uni/UniLogin'),
              LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                .default,
            })
          : require('../Account/Uni/UniLogin').default,
        exact: true,
      },
    ],
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () => import('../../layouts/BasicLayout'),
          LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/BasicLayout').default,
    Routes: [require('../Authorized').default],
    routes: [
      {
        path: '/hdmgr',
        name: 'hdmgr',
        icon: 'icon-management_uncheck',
        org: ['HEADING'],
        routes: [
          {
            path: '/hdmgr/comp',
            name: 'comp',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Company/Company'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Company/Company').default,
            divider: true,
            exact: true,
          },
          {
            path: '/hdmgr/licence',
            name: 'licence',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../License/License'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../License/License').default,
            divider: true,
            exact: true,
          },
          {
            path: '/hdmgr/server',
            name: 'server',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Server/Server'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Server/Server').default,
            divider: true,
            exact: true,
          },
          {
            path: '/hdmgr/RFManage',
            name: 'RFManage',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../RFmanage/RFmanage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../RFmanage/RFmanage').default,
            divider: true,
            exact: true,
          },
          {
            path: '/hdmgr/report',
            name: 'report',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Report/Report'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Report/Report').default,
            divider: true,
            exact: true,
          },
          {
            path: '/hdmgr/template',
            name: 'template',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Account/PrintTemplate/PrintTemplate'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/PrintTemplate/PrintTemplate').default,
            exact: true,
          },
          {
            path: '/hdmgr/onlinehelp',
            name: 'onlinehelp',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Onlinehelp/Onlinehelp'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Onlinehelp/Onlinehelp').default,
            exact: true,
          },
        ],
      },
      {
        path: '/compmgr',
        name: 'compmgr',
        icon: 'icon-menu_system',
        org: ['COMPANY', 'DC', 'STORE', 'CARRIER', 'VENDOR', 'OWNER'],
        authority: ['iwms.account'],
        routes: [
          {
            path: '/compmgr/role',
            name: 'role',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Role/Role'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Role/Role').default,
            authority: ['iwms.account.role'],
            exact: true,
          },
          {
            path: '/compmgr/user',
            name: 'user',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/User/User'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/User/User').default,
            authority: ['iwms.account.user'],
            exact: true,
          },
          {
            path: '/compmgr/config',
            name: 'config',
            org: ['COMPANY'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Config/Config'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Config/Config').default,
            authority: ['iwms.account.configcenter'],
            exact: true,
          },
          {
            path: '/compmgr/report',
            name: 'report',
            org: ['COMPANY'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Report/Report'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Report/Report').default,
            authority: ['iwms.account.report'],
            exact: true,
          },
          {
            path: '/compmgr/template',
            name: 'template',
            org: ['COMPANY'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Account/PrintTemplate/PrintTemplate'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/PrintTemplate/PrintTemplate').default,
            authority: ['iwms.account.print'],
            exact: true,
          },
          {
            path: '/compmgr/billImport',
            name: 'billImport',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/BillImport/BillImport'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/BillImport/BillImport').default,
            authority: ['iwms.account.billImport'],
            exact: true,
          },
          {
            path: '/compmgr/customImport',
            name: 'customImport',
            org: ['COMPANY', 'DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/CustomerImport/index'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/CustomerImport/index').default,
            authority: ['iwms.account.customimport'],
            exact: true,
          },
        ],
      },
      {
        path: '/basic',
        name: 'basic',
        icon: 'icon-menu_info',
        org: ['COMPANY', 'DC', 'OWNER'],
        authority: ['iwms.basic'],
        routes: [
          {
            path: '/basic/dc',
            name: 'dc',
            org: ['COMPANY'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/DC/DC'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/DC/DC').default,
            authority: ['iwms.basic.dc'],
            divider: true,
            exact: true,
          },
          {
            path: '/basic/owner',
            name: 'owner',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/Owner/Owner'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/Owner/Owner').default,
            authority: ['iwms.basic.owner'],
            exact: true,
          },
          {
            path: '/basic/vendor',
            name: 'vendor',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/Vendor/Vendor'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/Vendor/Vendor').default,
            authority: ['iwms.basic.vendor'],
            exact: true,
          },
          {
            path: '/basic/store',
            name: 'store',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/Store/Store'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/Store/Store').default,
            authority: ['iwms.basic.store'],
            exact: true,
          },
          {
            path: '/basic/category',
            name: 'category',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/Category/Category'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/Category/Category').default,
            authority: ['iwms.basic.category'],
            exact: true,
          },
          {
            path: '/basic/article',
            name: 'article',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/Article/Article'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/Article/Article').default,
            authority: ['iwms.basic.article'],
            exact: true,
          },
        ],
      },
      {
        path: '/facility',
        name: 'facility',
        icon: 'icon-menu_wuliusheshi',
        org: ['COMPANY', 'DC'],
        authority: ['iwms.facility'],
        routes: [
          {
            path: '/facility/wrh',
            name: 'wrh',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Basic/Wrh/Wrh'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Basic/Wrh/Wrh').default,
            authority: ['iwms.basic.wrh'],
            divider: true,
            exact: true,
          },
          {
            path: '/facility/binType',
            name: 'binType',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Facility/BinType/BinType'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/BinType/BinType').default,
            authority: ['iwms.facility.bintype'],
            exact: true,
          },
          {
            path: '/facility/bin',
            name: 'bin',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Facility/Bin/Bin'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/Bin/Bin').default,
            authority: ['iwms.facility.bin'],
            exact: true,
          },
          {
            path: '/facility/containerType',
            name: 'containerType',
            org: ['COMPANY', 'DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/ContainerType/ContainerType'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/ContainerType/ContainerType').default,
            authority: ['iwms.facility.containerType'],
            exact: true,
          },
          {
            path: '/facility/container',
            name: 'container',
            authority: ['iwms.facility.container'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Facility/Container/Container'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/Container/Container').default,
            exact: true,
          },
          {
            path: '/facility/dock',
            name: 'dock',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Facility/Dock/Dock'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/Dock/Dock').default,
            authority: ['iwms.facility.dock'],
            exact: true,
          },
          {
            path: '/facility/allocateWall',
            name: 'allocateWall',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/AllocateWall/AllocateWall'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/AllocateWall/AllocateWall').default,
            authority: ['iwms.facility.allocateWall'],
            divider: true,
            exact: true,
          },
          {
            path: '/facility/pickArea',
            name: 'pickArea',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Facility/PickArea/PickArea'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/PickArea/PickArea').default,
            authority: ['iwms.facility.pickarea'],
            exact: true,
          },
          {
            path: '/facility/dynamicpickupgroup',
            name: 'dynamicpickupgroup',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/DynamicPickupGroup/HomePage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/DynamicPickupGroup/HomePage').default,
            authority: ['iwms.facility.pickgrouparea'],
            exact: true,
          },
          {
            path: '/facility/highLowStock',
            name: 'highLowStock',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/HighLowStock/HighLowStock'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/HighLowStock/HighLowStock').default,
            authority: ['iwms.facility.highlowstock'],
            exact: true,
          },
          {
            path: '/facility/supermanagementboard',
            name: 'superManagementBoard',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/SuperManagementBoard/SuperManagementBoard'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/SuperManagementBoard/SuperManagementBoard')
                  .default,
            authority: ['iwms.facility.overprotectboard'],
            exact: true,
          },
          {
            path: '/facility/articleReplaceScheme',
            name: 'articleReplace',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/ArticleReplace/ArticleReplace'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/ArticleReplace/ArticleReplace').default,
            authority: ['iwms.facility.articleReplaceScheme'],
            divider: true,
            exact: true,
          },
          {
            path: '/facility/deliverycycle',
            name: 'deliverycycle',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/Deliverycycle/Deliverycycle'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/Deliverycycle/Deliverycycle').default,
            authority: ['iwms.facility.deliveryCycle'],
            exact: true,
          },
          {
            path: '/facility/stockorder',
            name: 'stockorder',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/StockOrder/StockOrder'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/StockOrder/StockOrder').default,
            authority: ['iwms.facility.stockOrderScheme'],
            exact: true,
          },
          {
            path: '/facility/storePickOrder',
            name: 'pickOrder',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/PickOrder/PickOrder'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/PickOrder/PickOrder').default,
            authority: ['iwms.facility.storePickScheme'],
            exact: true,
          },
          {
            path: '/facility/collectBinScheme',
            name: 'collectBin',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/CollectBin/CollectBin'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/CollectBin/CollectBin').default,
            authority: ['iwms.facility.collectBinScheme'],
            exact: true,
          },
          {
            path: '/facility/storeAllocationScheme',
            name: 'storeAllocationScheme',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Facility/StoreAllocationScheme/StoreAllocationScheme'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/StoreAllocationScheme/StoreAllocationScheme')
                  .default,
            authority: ['iwms.facility.storeAllocateBinScheme'],
            divider: true,
            exact: true,
          },
          {
            path: '/facility/config',
            name: 'config',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Facility/Config/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../Facility/Config/Config'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Facility/Config/Config').default,
            authority: [
              'iwms.facility.systemRequire',
              'iwms.facility.globalConfig',
              'iwms.facility.dataConfig',
              'iwms.facility.innerConfig',
              'iwms.facility.inConfig',
              'iwms.facility.putawayConfig',
              'iwms.facility.outConfig',
              'iwms.facility.rtnConfig',
              'iwms.facility.outConfig',
              'iwms.facility.dailyKnotsConfig',
              'iwms.facility.interfaceConfig',
              'iwms.facility.freshConfig',
              'iwms.facility.tmsConfig',
            ],
            exact: true,
          },
        ],
      },
      {
        path: '/in',
        name: 'in',
        org: ['DC', 'OWNER', 'VENDOR'],
        icon: 'icon-menu_rukuguanli',
        authority: ['iwms.in'],
        routes: [
          {
            path: '/in/order',
            name: 'order',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Order/Order'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Order/Order').default,
            authority: ['iwms.in.order'],
            exact: true,
          },
          {
            path: '/in/lcl',
            name: 'mixbox',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/MixboxOrder/MixboxOrder'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/MixboxOrder/MixboxOrder').default,
            authority: ['iwms.in.lcl'],
            divider: true,
            exact: true,
          },
          {
            path: '/in/bookboard',
            name: 'bookboard',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Book/BookBoard'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Book/BookBoard').default,
            authority: ['iwms.in.book'],
            exact: true,
          },
          {
            path: '/in/book',
            name: 'book',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Book/Book'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Book/Book').default,
            authority: ['iwms.in.book'],
            divider: true,
            exact: true,
          },
          {
            path: '/in/checkinwrh',
            name: 'checkinwrh',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/CheckInWrh/CheckInWrh'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/CheckInWrh/CheckInWrh').default,
            authority: ['iwms.in.inwrh.create'],
            exact: true,
          },
          {
            path: '/in/inwrhbill',
            name: 'inwrhbill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/InWrhBill/InWrhBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/InWrhBill/InWrhBill').default,
            authority: ['iwms.in.inwrh.board'],
            divider: true,
            exact: true,
          },
          {
            path: '/in/preCheck',
            name: 'precheck',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/In/PreCheck/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../In/PreCheck/PreCheck'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/PreCheck/PreCheck').default,
            authority: ['iwms.in.preCheck'],
            exact: true,
          },
          {
            path: '/in/receive',
            name: 'receive',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Receive/Receive'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Receive/Receive').default,
            authority: ['iwms.in.receive'],
            exact: true,
          },
          {
            path: '/in/planeMove',
            name: 'move',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Move/PlaneMoveBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Move/PlaneMoveBill').default,
            authority: ['iwms.in.move'],
            exact: true,
          },
          {
            path: '/in/putaway',
            name: 'putaway',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Putaway/Putaway'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Putaway/Putaway').default,
            authority: ['iwms.in.putaway'],
            divider: true,
            exact: true,
          },
          {
            path: '/in/adjBill',
            name: 'adjBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/AdjBill/AdjBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/AdjBill/AdjBill').default,
            authority: ['iwms.in.adj'],
            divider: true,
            exact: true,
          },
          {
            path: '/in/sense',
            name: 'senseCheck',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/Sense/SenseCheck'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/Sense/SenseCheck').default,
            authority: ['iwms.in.sense'],
            exact: true,
          },
          {
            path: '/in/physicscheckpool',
            name: 'physicscheckpool',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../In/PhysicsCheckPoolBoard/PhysicsCheckPoolBoard'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/PhysicsCheckPoolBoard/PhysicsCheckPoolBoard')
                  .default,
            authority: ['iwms.in.physicscheckpool'],
            exact: true,
          },
          {
            path: '/in/physicscheckntc',
            name: 'physicsCheckNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../In/PhysicsCheckNtc/PhysicsCheckNtcBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/PhysicsCheckNtc/PhysicsCheckNtcBill').default,
            authority: ['iwms.in.physicsCheckNtc'],
            exact: true,
          },
          {
            path: '/in/physicscheck',
            name: 'physicscheck',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../In/PhysicsCheck/PhysicsCheck'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/PhysicsCheck/PhysicsCheck').default,
            authority: ['iwms.in.physicscheck'],
            exact: true,
          },
          {
            path: '/in/freshReceive',
            name: 'freshReceive',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/In/FreshReceive/SmallerScreen/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../In/FreshReceive/SmallerScreen'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../In/FreshReceive/SmallerScreen').default,
            authority: ['iwms.in.freshReceive'],
            exact: true,
          },
        ],
      },
      {
        path: '/inner',
        name: 'inner',
        org: ['DC'],
        icon: 'icon-menu_neibuguanli',
        authority: ['iwms.inner'],
        routes: [
          {
            path: '/inner/movebill',
            name: 'movebill',
            authority: ['iwms.inner.moveBill'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/MoveBill/MoveBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/MoveBill/MoveBill').default,
            exact: true,
          },
          {
            path: '/inner/dec',
            name: 'dec',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/Dec/DecInvBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/Dec/DecInvBill').default,
            authority: ['iwms.inner.dec'],
            exact: true,
          },
          {
            path: '/inner/inc',
            name: 'inc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/Inc/IncInvBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/Inc/IncInvBill').default,
            authority: ['iwms.inner.inc'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/close',
            name: 'close',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/Close/WrhCloseBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/Close/WrhCloseBill').default,
            authority: ['iwms.inner.close'],
            exact: true,
          },
          {
            path: '/inner/stocklock',
            name: 'stocklock',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/StockLock/StockLockBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/StockLock/StockLockBill').default,
            authority: ['iwms.inner.lock'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/stockadj',
            name: 'stockAdjBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/StockAdjBill/StockAdjBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/StockAdjBill/StockAdjBill').default,
            authority: ['iwms.inner.stockAdjBill'],
            exact: true,
          },
          {
            path: '/inner/pickBinAdjBill',
            name: 'pickBinAdjBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/PickBinAdjBill/PickBinAdjBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/PickBinAdjBill/PickBinAdjBill').default,
            authority: ['iwms.inner.pickBinAdj'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/prerpl',
            name: 'prerpl',
            authority: ['iwms.inner.prerpl'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/PreRpl/PreRpl'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/PreRpl/PreRpl').default,
            divider: true,
            exact: true,
          },
          {
            path: '/inner/processingScheme',
            name: 'processingScheme',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Distribution/ProcessingScheme/ProcessingScheme'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Distribution/ProcessingScheme/ProcessingScheme')
                  .default,
            authority: ['iwms.inner.processScheme'],
            exact: true,
          },
          {
            path: '/inner/processTask',
            name: 'processTask',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/ProcessTask/ProcessTask'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ProcessTask/ProcessTask').default,
            authority: ['iwms.inner.processtask'],
            exact: true,
          },
          {
            path: '/inner/rawRequisitionTask',
            name: 'rawRequisitionTask',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/RawRequisitionTask/RawRequisitionTask'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/RawRequisitionTask/RawRequisitionTask')
                  .default,
            authority: ['iwms.inner.requisitionTask'],
            exact: true,
          },
          {
            path: '/inner/rawRequisitionBill',
            name: 'rawRequisitionBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/RawRequisitionBill/RawRequisitionBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/RawRequisitionBill/RawRequisitionBill')
                  .default,
            authority: ['iwms.inner.rawRequisitionBill'],
            exact: true,
          },
          {
            path: '/inner/webProcess',
            name: 'webProcess',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Inner/WebProcess/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../Inner/WebProcess/index'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/WebProcess/index').default,
            authority: ['iwms.inner.processWeb.view'],
            exact: true,
          },
          {
            path: '/inner/process',
            name: 'processBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/ProcessBill/ProcessBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ProcessBill/ProcessBill').default,
            authority: ['iwms.inner.processBill'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/stockTakePlanBill',
            name: 'stockTakePlan',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/StockTakePlan/StockTakePlan'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/StockTakePlan/StockTakePlan').default,
            authority: ['iwms.inner.stockTakePlan'],
            exact: true,
          },
          {
            path: '/inner/stockTakeBill',
            name: 'stockTakeBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/StockTakeBill/StockTakeBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/StockTakeBill/StockTakeBill').default,
            authority: ['iwms.inner.stockTake'],
            exact: true,
          },
          {
            path: '/inner/freshTake',
            name: 'freshTake',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Inner/FreshTake/FreshTakePage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/FreshTake/FreshTakePage').default,
            authority: ['iwms.inner.freshTake'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/containerAsset',
            name: 'containerAssert',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ContainerAssetShift/ContainerAssetShiftBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ContainerAssetShift/ContainerAssetShiftBill')
                  .default,
            authority: ['iwms.inner.containerAsset'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/electCert',
            name: 'electcert',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ElectCertBill/ElectCertBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ElectCertBill/ElectCertBill').default,
            authority: ['iwms.inner.electcert'],
            divider: true,
            exact: true,
          },
          {
            path: '/inner/consumingNtc',
            name: 'consumingNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ConsumingNtcBill/ConsumingNtcBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ConsumingNtcBill/ConsumingNtcBill').default,
            authority: ['iwms.inner.consumingntc'],
            exact: true,
          },
          {
            path: '/inner/consuming',
            name: 'consuming',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ConsumingBill/ConsumingBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ConsumingBill/ConsumingBill').default,
            authority: ['iwms.inner.consuming'],
            exact: true,
          },
          {
            path: '/inner/consumingRtn',
            name: 'consumingRtnBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ConsumingRtnBill/ConsumingRtnBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ConsumingRtnBill/ConsumingRtnBill').default,
            authority: ['iwms.inner.consumingRtn'],
            exact: true,
          },
        ],
      },
      {
        path: '/out',
        name: 'out',
        org: ['DC', 'OWNER'],
        icon: 'icon-menu_chukuguanli',
        authority: ['iwms.out'],
        routes: [
          {
            path: '/out/alcNtc',
            name: 'alcNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Out/AlcNtc/models/createPageData.js').then(
                      m => {
                        return { namespace: 'createPageData', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../Out/AlcNtc/AlcNtc'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/AlcNtc/AlcNtc').default,
            authority: ['iwms.out.alcntc'],
            exact: true,
          },
          {
            path: '/out/wave',
            name: 'waveBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Out/Wave/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../Out/Wave/WaveBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/Wave/WaveBill').default,
            divider: true,
            authority: ['iwms.out.wave'],
            exact: true,
          },
          {
            path: '/out/articleArrangement',
            name: 'articleArrangement',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/ArticleArrangement/ArticleArrangement'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/ArticleArrangement/ArticleArrangement').default,
            authority: ['iwms.out.pickDistribute.view'],
            exact: true,
          },
          {
            path: '/out/rpl',
            name: 'rpl',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/Rpl/Rpl'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/Rpl/Rpl').default,
            authority: ['iwms.out.rpl'],
            exact: true,
          },
          {
            path: '/out/pickup',
            name: 'pickUpBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/PickUp/PickUpBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/PickUp/PickUpBill').default,
            authority: ['iwms.out.pickup'],
            exact: true,
          },
          {
            path: '/out/PickupCombined',
            name: 'pickupCombined',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Out/PickupCombined/GroupPage/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import('../Out/PickupCombined/GroupPage/GroupPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/PickupCombined/GroupPage/GroupPage').default,
            authority: ['iwms.out.pickupcombined'],
            exact: true,
          },
          {
            path: '/out/sowingPickUp',
            name: 'sowingPickUp',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/SowingPickUp/SowingPickUpBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/SowingPickUp/SowingPickUpBill').default,
            authority: ['iwms.out.sowingpickup'],
            exact: true,
          },
          {
            path: '/out/labelTpick',
            name: 'labelTpick',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/LabelTpick/LabelTpickPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/LabelTpick/LabelTpickPage').default,
            authority: ['iwms.out.sowingPickLabelSummary'],
            exact: true,
          },
          {
            path: '/out/pickUpBillPrintLabel',
            name: 'pickUpBillPrintLabel',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/PickUpBillPrintLabel/PickUpBillPrintLabelPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/PickUpBillPrintLabel/PickUpBillPrintLabelPage')
                  .default,
            authority: ['iwms.out.pickUpBillPrintLabel'],
            exact: true,
          },
          {
            path: '/out/storePickAdjustPanel',
            name: 'storePickAdjustPanel',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/StorePickAdjustPanel/StorePickAdjustPanel'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/StorePickAdjustPanel/StorePickAdjustPanel')
                  .default,
            divider: true,
            authority: ['iwms.out.storePickAdjustPanel'],
            exact: true,
          },
          {
            path: '/out/containerItemreview',
            name: 'containerItemreview',
            authority: ['iwms.out.containerReviews'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Out/ContainerReview/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../Out/ContainerReview/index'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/ContainerReview/index').default,
            exact: true,
          },
          {
            path: '/out/containerreview',
            name: 'containerreview',
            authority: ['iwms.out.containerReview'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ContainerReviewBill/ContainerReviewBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ContainerReviewBill/ContainerReviewBill')
                  .default,
            exact: true,
          },
          {
            path: '/out/checkPack',
            name: 'checkPack',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/CheckPackPlate/CheckPackPlate'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/CheckPackPlate/CheckPackPlate').default,
            authority: ['iwms.out.checkPack'],
            exact: true,
          },
          {
            path: '/out/ecBill',
            name: 'ecBill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/EcBill/EcBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/EcBill/EcBill').default,
            authority: ['iwms.out.express'],
            exact: true,
          },
          {
            path: '/out/carriertransfer',
            name: 'carriertransfer',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/CarrierTransfer/CarrierTransfer'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/CarrierTransfer/CarrierTransfer').default,
            authority: ['iwms.out.carrierHandover'],
            divider: true,
            exact: true,
          },
          {
            path: '/out/collectbinreview',
            name: 'collectbinreview',
            authority: ['iwms.out.collectBinReview'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/CollectBinReviewBill/CollectBinReviewBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/CollectBinReviewBill/CollectBinReviewBill')
                  .default,
            exact: true,
          },
          {
            path: '/out/alcPrintDisboard',
            name: 'alcPrintDisboard',
            authority: ['iwms.out.alcNtcPrintBoard.view'],
            divider: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Out/AlcPrintDisboard/model.js').then(
                      m => {
                        return { namespace: 'model', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import('../Out/AlcPrintDisboard/PrintSearchPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/AlcPrintDisboard/PrintSearchPage').default,
            exact: true,
          },
          {
            path: '/out/containermerger',
            name: 'containermerger',
            authority: ['iwms.out.containerMerger'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ContainerMergerBill/ContainerMergerBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ContainerMergerBill/ContainerMergerBill')
                  .default,
            exact: true,
          },
          {
            path: '/out/containerbind',
            name: 'containerbind',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Inner/ContainerBindBill/ContainerBindBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Inner/ContainerBindBill/ContainerBindBill').default,
            authority: ['iwms.out.containerBind'],
            divider: true,
            exact: true,
          },
          {
            path: '/out/displayBoard',
            name: 'displayBoard',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/DisplayBoard/DisplayBoard'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/DisplayBoard/DisplayBoard').default,
            authority: ['iwms.out.displayBoard'],
            exact: true,
          },
          {
            path: '/out/processwave',
            name: 'processWave',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/ProcessWave/ProcessWavePage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/ProcessWave/ProcessWavePage').default,
            authority: ['iwms.out.processWave'],
            exact: true,
          },
          {
            path: '/out/pickTask',
            name: 'pickInstruct',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/PickInstruct/PickInstruct'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/PickInstruct/PickInstruct').default,
            authority: ['iwms.out.pickTask'],
            exact: true,
          },
          {
            path: '/out/freshPickUp',
            name: 'freshPickUp',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Out/FreshPickUp/FreshPickUp'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/FreshPickUp/FreshPickUp').default,
            authority: ['iwms.out.freshPickUp'],
            exact: true,
          },
          {
            path: '/out/picking',
            name: 'picking',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/FreshPickUp/PickingViewPage/PickingPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/FreshPickUp/PickingViewPage/PickingPage')
                  .default,
            authority: ['iwms.out.picking'],
            exact: true,
          },
          {
            path: '/out/sow',
            name: 'sow',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/FreshPickUp/SowViewPage/SowPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/FreshPickUp/SowViewPage/SowPage').default,
            authority: ['iwms.out.sow'],
            exact: true,
          },
          {
            path: '/out/crossAllocate',
            name: 'crossAllocate',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Out/CrossAllocateDisplayBoard/CrossAllocateSearchPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/CrossAllocateDisplayBoard/CrossAllocateSearchPage')
                  .default,
            authority: ['iwms.out.crossAllocate'],
            exact: true,
          },
        ],
      },
      {
        path: '/rtn',
        name: 'rtn',
        org: ['DC', 'OWNER'],
        icon: 'icon-menu_nixiangwuliu',
        authority: ['iwms.rtn'],
        routes: [
          {
            path: '/rtn/alcDiff',
            name: 'alcDiff',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/AlcDiff/AlcDiffBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/AlcDiff/AlcDiffBill').default,
            authority: ['iwms.tms.alcDiff'],
            exact: true,
          },
          {
            path: '/rtn/storeRtnNtc',
            name: 'storeRtnNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Rtn/StoreRtnNtc/StoreRtnNtcBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/StoreRtnNtc/StoreRtnNtcBill').default,
            authority: ['iwms.rtn.storeRtnNtc'],
            exact: true,
          },
          {
            path: '/rtn/storeRtn',
            name: 'storeRtn',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Rtn/StoreRtn/StoreRtnBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/StoreRtn/StoreRtnBill').default,
            authority: ['iwms.rtn.storeRtn'],
            exact: true,
          },
          {
            path: '/rtn/rtnPutaway',
            name: 'rtnPutaway',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Rtn/RtnPutaway/RtnPutawayBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/RtnPutaway/RtnPutawayBill').default,
            authority: ['iwms.rtn.rtnPutaway'],
            divider: true,
            exact: true,
          },
          {
            path: '/rtn/vendorDispatch',
            name: 'vendorDispatch',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Rtn/VendorDispatch/VendorDispatch'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/VendorDispatch/VendorDispatch').default,
            authority: ['iwms.rtn.vendorRtnDispatch'],
            exact: true,
          },
          {
            path: '/rtn/vendorRtnNtc',
            name: 'vendorRtnNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Rtn/VendorRtnNtc/VendorRtnNtcBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/VendorRtnNtc/VendorRtnNtcBill').default,
            authority: ['iwms.rtn.vendorRtnNtc'],
            exact: true,
          },
          {
            path: '/rtn/vendorRtnPick',
            name: 'vendorRtnPick',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Rtn/VendorRtnPick/VendorRtnPickBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/VendorRtnPick/VendorRtnPickBill').default,
            authority: ['iwms.rtn.vendorRtnPick'],
            exact: true,
          },
          {
            path: '/rtn/vendorHandover',
            name: 'vendorHandover',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Rtn/VendorHandover/VendorHandoverBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/VendorHandover/VendorHandoverBill').default,
            authority: ['iwms.rtn.vendorRtnHandover'],
            exact: true,
          },
        ],
      },
      {
        path: '/wcs',
        name: 'wcs',
        org: ['DC'],
        icon: 'icon-menu_wcs',
        authority: ['iwms.wcs'],
        routes: [
          {
            path: '/wcs/dps',
            name: 'dps',
            authority: ['iwms.wcs.dps'],
            routes: [
              {
                path: '/wcs/dps/pickUpBillElectronicLabel',
                name: 'pickUpBillElectronicLabel',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Dps/PickUpBillElectronicLabel/PickUpBillElectronicLabelPage'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Dps/PickUpBillElectronicLabel/PickUpBillElectronicLabelPage')
                      .default,
                authority: ['iwms.wcs.dps.electronicLabel.view'],
                exact: true,
              },
              {
                path: '/wcs/dps/ElectronicLabelLog',
                name: 'ElectronicLabelLog',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Dps/ElectronicLabelLog/ElectronicLabelLogPage'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Dps/ElectronicLabelLog/ElectronicLabelLogPage')
                      .default,
                authority: ['iwms.wcs.dps.electronicLabelLog.view'],
                divider: true,
                exact: true,
              },
              {
                path: '/wcs/dps/facilitiesMaintenance',
                name: 'facilitiesMaintenance',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Dps/FacilitiesMaintenance/FacilitiesMaintenance'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Dps/FacilitiesMaintenance/FacilitiesMaintenance')
                      .default,
                authority: ['iwms.wcs.dps.facilitiesMaintenance.view'],
                divider: true,
                exact: true,
              },
              {
                path: '/wcs/dps/operationPoint',
                name: 'operationPoint',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Dps/OperationPoint/OperationPoint'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Dps/OperationPoint/OperationPoint').default,
                authority: ['iwms.wcs.dps.operationPoint.view'],
                divider: true,
                exact: true,
              },
              {
                path: '/wcs/dps/job',
                name: 'job',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Wcs/Dps/Job/Job'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Dps/Job/Job').default,
                authority: ['iwms.wcs.dps.job.view'],
                divider: true,
                exact: true,
              },
            ],
          },
          {
            path: '/wcs/hangWeight',
            name: 'hangWeight',
            authority: ['iwms.wcs.hangWeightSowing'],
            routes: [
              {
                path: '/wcs/hangWeight/hangWeightSowing',
                name: 'hangWeightSowing',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/HangWeight/HangWeightSowing/HangWeightSowing'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/HangWeight/HangWeightSowing/HangWeightSowing')
                      .default,
                authority: ['iwms.wcs.hangWeightSowing.view'],
                exact: true,
              },
            ],
          },
          {
            path: '/wcs/electronicBalance',
            name: 'electronicBalance',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Wcs/ElectronicBalance/ElectronicBalanceConfig'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Wcs/ElectronicBalance/ElectronicBalanceConfig')
                  .default,
            authority: ['iwms.wcs.electronicBalance.view'],
            exact: true,
          },
          {
            path: '/wcs/packager',
            name: 'packager',
            authority: ['iwms.wcs.packager'],
            routes: [
              {
                path: '/wcs/packager/packDeviceConfig',
                name: 'packDeviceConfig',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/PackDeviceConfig/PackDeviceConfig'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/PackDeviceConfig/PackDeviceConfig')
                      .default,
                authority: ['iwms.wcs.packager.packageMachineConfig.view'],
                exact: true,
              },
              {
                path: '/wcs/packager/consumable',
                name: 'consumable',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/Consumable/Consumable'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/Consumable/Consumable').default,
                authority: ['iwms.wcs.packager.consumable.view'],
                exact: true,
              },
              {
                path: '/wcs/packager/articleConsumable',
                name: 'articleConsumable',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/ArticleConsumable/ArticleConsumable'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/ArticleConsumable/ArticleConsumable')
                      .default,
                authority: ['iwms.wcs.packager.articleConsumable.view'],
                exact: true,
              },
              {
                path: '/wcs/packager/instructBoard',
                name: 'instructBoard',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/InstructBoard/InstructBoard'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/InstructBoard/InstructBoard')
                      .default,
                authority: ['iwms.wcs.packager.picktask.view'],
                exact: true,
              },
            ],
          },
          {
            path: '/wcs/sorter',
            name: 'sorter',
            authority: ['iwms.wcs.sortingMachine'],
            routes: [
              {
                path: '/wcs/sorter/stockManage',
                name: 'stockManage',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/StockManage/StockManage'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/StockManage/StockManage').default,
                authority: [
                  'iwms.wcs.sortingMachine.inventorymanagerconfig.view',
                ],
                exact: true,
              },
              {
                path: '/wcs/sorter/sortCrossing',
                name: 'sortCrossing',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/SortCrossing/SortCrossing'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/SortCrossing/SortCrossing').default,
                authority: ['iwms.wcs.sortingMachine.sortCrossing.view'],
                exact: true,
              },
              {
                path: '/wcs/sorter/sortStrategy',
                name: 'sortStrategy',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/SortStrategy/SortStrategy'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/SortStrategy/SortStrategy').default,
                authority: ['iwms.wcs.sortingMachine.sortStrategy.view'],
                exact: true,
              },
              {
                path: '/wcs/sorter/sortorder',
                name: 'sortorder',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Sorter/SorterOrderBoard/SorterOrderBoard'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Sorter/SorterOrderBoard/SorterOrderBoard')
                      .default,
                authority: ['iwms.wcs.sortingMachine.sortertaskboard.view'],
                exact: true,
              },
            ],
          },
          {
            path: '/wcs/agv',
            name: 'agv',
            authority: ['iwms.wcs.agv.view'],
            routes: [
              {
                path: '/wcs/agv/agvin',
                name: 'agvin',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Wcs/Agv/Agvin/Agvin'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Agv/Agvin/Agvin').default,
                exact: true,
              },
              {
                path: '/wcs/agv/agvout',
                name: 'agvout',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Wcs/Agv/Agvout/Agvout'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Agv/Agvout/Agvout').default,
                exact: true,
              },
              {
                path: '/wcs/agv/agvinner',
                name: 'agvinner',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () => import('../Wcs/Agv/Agvinner/Agvinner'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Agv/Agvinner/Agvinner').default,
                exact: true,
              },
            ],
          },
          {
            path: '/wcs/asrs',
            name: 'asrs',
            authority: ['iwms.wcs.asrs.view'],
            exact: true,
          },
          {
            path: '/wcs/print',
            name: 'print',
            authority: ['iwms.wcs.print'],
            routes: [
              {
                path: '/wcs/print/printplug',
                name: 'printplug',
                component: __IS_BROWSER
                  ? _dvaDynamic({
                      component: () =>
                        import('../Wcs/Print/Printplug/Printplug'),
                      LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                        .default,
                    })
                  : require('../Wcs/Print/Printplug/Printplug').default,
                exact: true,
              },
            ],
          },
        ],
      },
      {
        path: '/dcmgr',
        name: 'dcmgr',
        org: ['COMPANY'],
        authority: ['iwms.dcmgr'],
        icon: 'icon-menu_cangchuguanli',
        routes: [
          {
            path: '/dcmgr/processingScheme',
            name: 'processingScheme',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Distribution/ProcessingScheme/ProcessingScheme'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Distribution/ProcessingScheme/ProcessingScheme')
                  .default,
            authority: ['iwms.dcmgr.processScheme'],
            exact: true,
          },
        ],
      },
      {
        path: '/tms',
        name: 'tms',
        org: ['COMPANY', 'DC', 'OWNER'],
        authority: ['iwms.tms'],
        icon: 'icon-menu_yunshuguanli1',
        routes: [
          {
            path: '/tms/serialArch',
            name: 'serialArch',
            org: ['COMPANY', 'DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/SerialArch/SerialArch'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/SerialArch/SerialArch').default,
            authority: ['iwms.tms.serialArch'],
            exact: true,
          },
          {
            path: '/tms/carrier',
            name: 'carrier',
            org: ['COMPANY', 'DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/Carrier/Carrier'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/Carrier/Carrier').default,
            authority: ['iwms.tms.carrier'],
            divider: true,
            exact: true,
          },
          {
            path: '/tms/vehicleType',
            name: 'vehicleType',
            org: ['COMPANY', 'DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/VehicleType/VehicleType'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/VehicleType/VehicleType').default,
            authority: ['iwms.tms.vehicleType'],
            exact: true,
          },
          {
            path: '/tms/vehicle',
            name: 'vehicle',
            org: ['COMPANY', 'DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/Vehicle/Vehicle'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/Vehicle/Vehicle').default,
            authority: ['iwms.tms.vehicle'],
            divider: true,
            exact: true,
          },
          {
            path: '/tms/ShipPlanDispatch',
            name: 'ShipPlanDispatch',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Tms/ShipPlanDispatch/ShipPlanDispatch'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/ShipPlanDispatch/ShipPlanDispatch').default,
            authority: ['iwms.tms.shipPlanDispatch'],
            exact: true,
          },
          {
            path: '/tms/shipplanbill',
            name: 'shipplanbill',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/ShipPlanBill/ShipPlanBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/ShipPlanBill/ShipPlanBill').default,
            authority: ['iwms.tms.shipPlanBill'],
            exact: true,
          },
          {
            path: '/tms/shipbill',
            name: 'shipbill',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/ShipBill/ShipBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/ShipBill/ShipBill').default,
            authority: ['iwms.tms.shipBill'],
            exact: true,
          },
          {
            path: '/tms/storeHandover',
            name: 'storehandoverbill',
            org: ['DC', 'OWNER'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Tms/StoreHandoverBill/StoreHandoverBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/StoreHandoverBill/StoreHandoverBill').default,
            authority: ['iwms.tms.storeHandover'],
            divider: true,
            exact: true,
          },
          {
            path: '/tms/vehicleMonitoring',
            name: 'vehicleMonitoring',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/Map/TmsMap'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/Map/TmsMap').default,
            authority: ['iwms.tms.vehicleMonitoring'],
            exact: true,
          },
          {
            path: '/tms/containerRecycle',
            name: 'containerRecycle',
            org: ['DC'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Tms/ContainerRecycle/ContainerRecycle'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/ContainerRecycle/ContainerRecycle').default,
            authority: ['iwms.tms.containerRecycle'],
            exact: true,
          },
        ],
      },
      {
        path: '/call',
        name: 'call',
        org: ['STORE'],
        authority: ['iwms.call'],
        icon: 'icon-menu_chukuguanli',
        routes: [
          {
            path: '/call/alcNtc',
            name: 'alcNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/pages/Out/AlcNtc/models/createPageData.js').then(
                      m => {
                        return { namespace: 'createPageData', ...m.default };
                      },
                    ),
                  ],
                  component: () => import('../Out/AlcNtc/AlcNtc'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Out/AlcNtc/AlcNtc').default,
            authority: ['iwms.call.alcntc'],
            exact: true,
          },
          {
            path: '/call/storeHandover',
            name: 'storeHandover',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Tms/StoreHandoverBill/StoreHandoverBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/StoreHandoverBill/StoreHandoverBill').default,
            authority: ['iwms.call.storeHandover'],
            exact: true,
          },
          {
            path: '/call/vehicleMonitoring',
            name: 'vehicleMonitoring',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/Map/TmsMap'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/Map/TmsMap').default,
            authority: ['iwms.call.vehicleMonitoring'],
            exact: true,
          },
        ],
      },
      {
        path: '/rtnMsg',
        name: 'rtnMsg',
        org: ['STORE'],
        icon: 'icon-menu_nixiangwuliu',
        authority: ['iwms.rtnMsg'],
        routes: [
          {
            path: '/rtnMsg/storeRtnNtc',
            name: 'storeRtnNtc',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Rtn/StoreRtnNtc/StoreRtnNtcBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/StoreRtnNtc/StoreRtnNtcBill').default,
            authority: ['iwms.rtnMsg.storeRtnNtc'],
            exact: true,
          },
          {
            path: '/rtnMsg/storeRtn',
            name: 'storeRtn',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Rtn/StoreRtn/StoreRtnBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Rtn/StoreRtn/StoreRtnBill').default,
            authority: ['iwms.rtnMsg.storeRtn'],
            exact: true,
          },
        ],
      },
      {
        path: '/tmsMsg',
        name: 'tmsMsg',
        org: ['CARRIER'],
        authority: ['iwms.tmsMsg'],
        icon: 'icon-menu_yunshuguanli1',
        routes: [
          {
            path: '/tmsMsg/vehicle',
            name: 'vehicle',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/Vehicle/Vehicle'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/Vehicle/Vehicle').default,
            authority: ['iwms.tmsMsg.vehicle'],
            exact: true,
          },
          {
            path: '/tmsMsg/shipplanbill',
            name: 'shipplanbill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/ShipPlanBill/ShipPlanBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/ShipPlanBill/ShipPlanBill').default,
            authority: ['iwms.tmsMsg.shipPlanBill'],
            exact: true,
          },
          {
            path: '/tmsMsg/shipbill',
            name: 'shipbill',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/ShipBill/ShipBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/ShipBill/ShipBill').default,
            authority: ['iwms.tmsMsg.shipBill'],
            exact: true,
          },
          {
            path: '/tmsMsg/storeHandover',
            name: 'storeHandover',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Tms/StoreHandoverBill/StoreHandoverBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/StoreHandoverBill/StoreHandoverBill').default,
            authority: ['iwms.tmsMsg.storeHandover'],
            exact: true,
          },
          {
            path: '/tmsMsg/vehicleMonitoring',
            name: 'vehicleMonitoring',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Tms/Map/TmsMap'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Tms/Map/TmsMap').default,
            authority: ['iwms.tmsMsg.vehicleMonitoring'],
            exact: true,
          },
        ],
      },
      {
        path: '/bigdata',
        name: 'bigData',
        icon: 'icon-menu_data1',
        routes: [
          {
            path: '/bigdata/:folder/:report',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Report/ReportPage'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Report/ReportPage').default,
            exact: true,
          },
        ],
      },
      {
        path: '/notice',
        name: 'notice',
        icon: 'icon-menu_notice',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () => import('../Basic/Notice/Notice'),
              LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                .default,
            })
          : require('../Basic/Notice/Notice').default,
        authority: ['iwms.system.notice'],
        exact: true,
      },
      {
        path: '/api',
        name: 'api',
        icon: 'icon-menu_jiekoupingtai',
        org: ['COMPANY'],
        authority: ['iwms.api'],
        routes: [
          {
            path: '/api/config',
            name: 'config',
            org: ['COMPANY'],
            authority: ['iwms.api.config'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Api/config'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Api/config').default,
            exact: true,
          },
          {
            path: '/api/notify',
            name: 'notify',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Api/Notify'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Api/Notify').default,
            org: ['COMPANY'],
            authority: ['iwms.api.notify'],
            exact: true,
          },
          {
            path: '/api/erpdown',
            name: 'erpdown',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Api/Down'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Api/Down').default,
            org: ['COMPANY'],
            authority: ['iwms.api.erpdown'],
            exact: true,
          },
          {
            path: '/api/erpup',
            name: 'erpup',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Api/Up'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Api/Up').default,
            org: ['COMPANY'],
            authority: ['iwms.api.erpup'],
            exact: true,
          },
          {
            path: '/api/wcsdown',
            name: 'wcsdown',
            org: ['COMPANY'],
            authority: ['iwms.api.wcsdown'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Api/WCSDown'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Api/WCSDown').default,
            exact: true,
          },
          {
            path: '/api/wcsup',
            name: 'wcsup',
            org: ['COMPANY'],
            authority: ['iwms.api.wcsup'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Api/WCSUp'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Api/WCSUp').default,
            exact: true,
          },
        ],
      },
      {
        path: '/bms',
        name: 'bms',
        org: ['COMPANY'],
        icon: 'icon-menu_jifeiguanli',
        authority: ['iwms.bms'],
        routes: [
          {
            path: '/bms/cost',
            name: 'cost',
            authority: ['iwms.bms.cost'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/Cost'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/Cost').default,
            exact: true,
          },
          {
            path: '/bms/sortScheme',
            name: 'sortScheme',
            authority: ['iwms.bms.sortScheme'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/SortScheme'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/SortScheme').default,
            exact: true,
          },
          {
            path: '/bms/dataSource',
            name: 'dataSource',
            authority: ['iwms.bms.dataSource'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/DataSource'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/DataSource').default,
            exact: true,
          },
          {
            path: '/bms/contract',
            name: 'contract',
            authority: ['iwms.bms.contract'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/Contract'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/Contract').default,
            exact: true,
          },
          {
            path: '/bms/genFeeBill',
            name: 'genFeeBill',
            authority: ['iwms.bms.genFeeBill'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/GenFeeBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/GenFeeBill').default,
            exact: true,
          },
          {
            path: '/bms/feeBill',
            name: 'feeBill',
            authority: ['iwms.bms.feeBill'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/FeeBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/FeeBill').default,
            exact: true,
          },
          {
            path: '/bms/accountBill',
            name: 'accountBill',
            authority: ['iwms.bms.accountBill'],
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Bms/AccountBill'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Bms/AccountBill').default,
            exact: true,
          },
        ],
      },
      {
        path: '/account',
        name: 'account',
        hideInMenu: true,
        routes: [
          {
            path: '/account/center',
            name: 'center',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Profile/Profile'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Profile/Profile').default,
            exact: true,
          },
          {
            path: '/account/version',
            name: 'version',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () => import('../Account/Version/Version'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/Version/Version').default,
            exact: true,
          },
          {
            path: '/account/loginConfig',
            name: 'loginConfig',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Account/LoginandIndexConfig/LoginConfig'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/LoginandIndexConfig/LoginConfig').default,
            exact: true,
          },
          {
            path: '/account/homeConfig',
            name: 'homeConfig',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import('../Account/LoginandIndexConfig/HomeConfig'),
                  LoadingComponent: require('/var/jenkins_home/workspace/iWMS/iWMS-web-release-test/src/components/PageLoading/index')
                    .default,
                })
              : require('../Account/LoginandIndexConfig/HomeConfig').default,
            exact: true,
          },
        ],
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
